import React from 'react';
import { Modal, Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const FilePreviewModal = ({ open, handleClose, fileUrl, fileType }) => {
    const getFileExtension = (url) => {
        try {
            if (typeof url === 'string')
                return url?.split('.')?.pop()?.toLowerCase();
            else return '';
        } catch (err) {
            return "";
        }

    }
    const getVideoMimeType = (url) => {
        const extension = getFileExtension(url); // url?.split('.').pop()?.toLowerCase();
        const mimeTypes = {
            mp4: "video/mp4",
            webm: "video/webm",
            ogg: "video/ogg",
            mov: "video/quicktime",
            avi: "video/x-msvideo",
            wmv: "video/x-ms-wmv",
            flv: "video/x-flv",
        };
        return mimeTypes[extension] || "video/mp4";
    };

    const isWordDocument = (ext) => ['doc', 'docx'].includes(ext);
    const isExcelDocument = (ext) => ['xls', 'xlsx'].includes(ext);
    const isPowerPoint = (ext) => ['ppt', 'pptx'].includes(ext);
    const isPdf = (ext) => ext === 'pdf';
    const isTextFile = (ext) => ['txt', 'json', 'xml', 'csv', 'html'].includes(ext);

    const fileExtension = getFileExtension(fileUrl);

    return (
        <Modal open={open} onClose={handleClose}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 700,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 3,
                    borderRadius: '8px',
                    textAlign: 'center'
                }}
            >
                <IconButton
                    sx={{ position: 'absolute', top: 5, right: 5 }}
                    onClick={handleClose}
                >
                    <CloseIcon />
                </IconButton>

                <Typography variant="h6" sx={{ mb: 2 }}>{fileType} Preview</Typography>

                {/* IMAGE PREVIEW */}
                {fileType.toUpperCase() === 'IMAGE' && fileUrl && (
                    <img src={fileUrl} alt="Preview" style={{ width: '100%', maxHeight: '400px', objectFit: 'contain' }} />
                )}

                {/* VIDEO PREVIEW */}
                {fileType.toUpperCase() === 'VIDEO' && fileUrl && (
                    <video controls style={{ width: '100%' }} src={fileUrl} type={getVideoMimeType(fileUrl)}>
                        Your browser does not support the video tag.
                    </video>
                )}

                {/* PDF PREVIEW */}
                {isPdf(fileExtension) && fileUrl && (
                    <object
                        data={`${fileUrl}#toolbar=0`}
                        type="application/pdf"
                        width="100%"
                        height="400px"
                    >
                        <p>PDF preview is not supported in your browser. <a href={fileUrl} target="_blank" rel="noopener noreferrer">Download PDF</a></p>
                    </object>
                )}

                {/* TEXT FILE PREVIEW */}
                {isTextFile(fileExtension) && fileUrl && (
                    <iframe src={fileUrl} width="100%" height="400px" style={{ border: "1px solid #ddd" }} title="Text File Preview"></iframe>
                )}

                {/* WORD, EXCEL, POWERPOINT PREVIEW (Google Docs Viewer) */}
                {(isWordDocument(fileExtension) || isExcelDocument(fileExtension) || isPowerPoint(fileExtension)) && fileUrl && (
                    <iframe
                        src={`https://docs.google.com/gview?url=${fileUrl}&embedded=true`}
                        width="100%"
                        height="400px"
                        style={{ border: "none" }}
                        title="Office Document Preview"
                    ></iframe>
                )}

                {/* ERROR MESSAGE */}
                {!fileUrl && <Typography color="error">File not available</Typography>}
            </Box>
        </Modal>
    );
};

export default FilePreviewModal;